import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import TermsPage from './components/TermsPage';
import AboutPage from './components/AboutPage';
import PrivacyPage from './components/PrivacyPage';
import AuthCallback from './components/AuthCallback';
import CreditSuccess from './components/CreditSuccess';
import CreditCancel from './components/CreditCancel';

const AdminDashboard = React.lazy(() => import('./components/AdminDashboard'));
const ApiKeysPage = React.lazy(() => import('./components/ApiKeysPage'));
const HistoryPage = React.lazy(() => import('./components/HistoryPage'));

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/map" element={<App />} />
      <Route path="/imagelist" element={<App />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/credits/success" element={<CreditSuccess />} />
      <Route path="/credits/cancel" element={<CreditCancel />} />
      <Route path="/admin" element={<React.Suspense fallback={<div>Loading...</div>}><AdminDashboard /></React.Suspense>} />
      <Route path="/api" element={<React.Suspense fallback={<div>Loading...</div>}><ApiKeysPage /></React.Suspense>} />
      <Route path="/history" element={<React.Suspense fallback={<div>Loading...</div>}><HistoryPage /></React.Suspense>} />
      <Route path="*" element={<App />} />
    </Routes>
  </Router>
);
